document.addEventListener('DOMContentLoaded', function() {
  (function($) {
    var percentagePeak = 90;
    var breakpoint = '640px';

    var checkHeight = function(){
      if (window.matchMedia(`(max-width: ${breakpoint})`).matches) {
        $(".pcc-island-slider").each(function() {
          var slider_parent = $(this);
          var slides = $(slider_parent).find('.pcc-slider__slide');
          var max_height = 0;
            slides.each(function() {
              var my_height = $(this).outerHeight();
              console.log(my_height + ' > ' +  max_height + ' = ' + (my_height > max_height))
              if(my_height > max_height){
                max_height = my_height
              }
            });
            console.log(max_height)
            $(slider_parent).css('height', max_height);
            $('.pcc-slider__container').css('height', max_height);
        });
      } else{
        $('.pcc-island-slider').css('height', '');
        $('.pcc-slider__container').css('height', '');
      }
    }
    $(window).on('resize', checkHeight);
    checkHeight();
    $(".pcc-island-slider").each(function() {
      var hammerClass = new Hammer(this);
      hammerClass.get('swipe').set({ direction: Hammer.DIRECTION_HORIZONTAL });
      hammerClass.on('swipe', handleSwipe);

      var that = $(this);
      var slides = that.find('.pcc-slider__slide');
      var skip = false;
      var nextButton = that.find('.scrollRight');
      var prevButton = that.find('.scrollLeft');

      nextButton[0].addEventListener('click', function() {
          var simulatedEvent = {
            target: this,
            direction: Hammer.DIRECTION_LEFT,
            type: 'swipe'
        };

        hammerClass.emit('swipe', simulatedEvent);
      });

      prevButton[0].addEventListener('click', function() {
        var simulatedEvent = {
          target: this,
          direction: Hammer.DIRECTION_RIGHT,
          type: 'swipe'
      };

      hammerClass.emit('swipe', simulatedEvent);
    });
      
      slides.each(function() {
        var image = $(this).children();
        var skip_img = $(this).hasClass('skip_img');
        if (image[0].tagName == "IMG" && !skip_img){
          image[0].replaceWith(turnToDiv(image[0]));
        }else{
          skip = true;
        }
      });
      var leftPercentage = 0;
      if(!skip){
        var divs = slides.children('div');
        divs.each(function() {
          that = $(this);
          if (that.attr("src")) that.css("background-image", 'url("' + that.attr("src") + '")');
          that.parent().css("left", leftPercentage + "%")
          leftPercentage += percentagePeak;
        });
      }else{
        var max_height = 0;
        slides.each(function() {
          $(this).css("left", leftPercentage + "%");
          if($(this).height() > max_height){
            max_height = $(this).height();
          }
          leftPercentage += percentagePeak;
        });
        $(that).css('height', max_height);
      }
    });

    $(window).on('resize', resizeGalleryText);
    resizeGalleryText();

    function handleSwipe(e) {
      if (window.matchMedia(`(min-width: ${breakpoint})`).matches) return;
      var that = $(e.target);
      var slider = that.closest('.pcc-island-slider').find('.pcc-slider__container ul');
      switch (e.direction) {
        case 2:
          var slidePosition = slider[0].style.left ? parseInt(slider[0].style.left) : slider[0].style.left = "0";
          slidePosition -= percentagePeak;
          pcc_slide_animate(slidePosition);
        break;
        case 4:
          var slidePosition = parseInt(slider[0].style.left);
          slidePosition += percentagePeak;
          pcc_slide_animate(slidePosition);
        break;
        default:
          return;
        break;
      }

      function pcc_slide_animate(leftValue) {
        if (-leftValue/percentagePeak == slider.eq(0).children().length) {
          leftValue = 0;
        } else if (-leftValue/percentagePeak < 0) {
          leftValue = -(percentagePeak * (slider.eq(0).children().length - 1));
        }
        slider.eq(0).css("left", leftValue + "%");
      }
    }

    function turnToDiv(elem) {
      var newElem = document.createElement('div'),
          i,
          prop,
          attr = elem.attributes,
          attrLen = attr.length;

      elem = elem.cloneNode(true);
      while (elem.firstChild) {
        newElem.appendChild(elem.firstChild);
      }

      for (i in elem) {
        try {
          prop = elem[i];
          if (prop && i !== 'outerHTML' && (typeof prop === 'string' || typeof prop === 'number')) {
            newElem[i] = elem[i];
          }
        }
        catch(err) {}

        for (i = 0; i < attrLen; i++) {
          newElem.setAttribute(attr[i].nodeName, attr[i].nodeValue);
        }

        newElem.style.cssText = elem.style.cssText;
        return newElem;
      }
    }

    function resizeGalleryText() {
      var galleryTextContainers = $('.gallery-info'),
          galleryTextContainerHeight = galleryTextContainers[0].clientHeight,
          currentHeight = 9999,
          newHeight = 0,
          greatestHeight = 0,
          startingFontSize = currentFontSize = 14,
          greatestHeightContainer
      ;
      galleryTextContainers.css('font-size', startingFontSize + "px");

      // Get the largest content height
      galleryTextContainers.each(function() {
        var that = $(this);

        var contentHeight = getChildrenHeight(that);
        if (contentHeight > greatestHeight) {
          greatestHeight = contentHeight;
          greatestHeightContainer = that;
        }
      });

      currentHeight = greatestHeight;

      if (currentHeight > galleryTextContainerHeight) {
        while (currentHeight > galleryTextContainerHeight - 5 && currentFontSize > 5) {
          currentFontSize -= 0.5;
          greatestHeightContainer.css('font-size', currentFontSize + "px");
          currentHeight = getChildrenHeight(greatestHeightContainer);
        }
        galleryTextContainers.css('font-size', currentFontSize + "px");
      }

      function getChildrenHeight(container) {
        var contentHeight = 0;
        container.children().each(function() {
          contentHeight += this.clientHeight;
        });
        return contentHeight;
      }
    }

  })(jQuery);
});
